// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import A1 from '../Images/logo-w.png';

// const Login = () => {
//   const [email_id, setEmailId] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const loginData = { email_id, password };

//     try {
//       if (email_id === 'admin.erp@gmail.com' && password === 'admin') {
//         const userData = { email: email_id, name: 'Admin' };
//         const token = 'mock-token-for-admin';
//         sessionStorage.setItem('user', JSON.stringify(userData));
//         sessionStorage.setItem('authToken', token);
//         setSuccess('Login successful!');
//         setError('');
//         navigate('/admindashboard-admindashboard'); // Admin dashboard
//       } else {
//         const response = await fetch('https://erpapi.emedha.in/auth/api/login', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(loginData),
//         });
//         const result = await response.json();
//         if (response.ok) {
//           const userData = result.user;
//           const token = result.token;
//           sessionStorage.setItem('user', JSON.stringify(userData));
//           sessionStorage.setItem('authToken', token);
//           if (userData) {
//             navigate('/dashboard');
//           }
//           setSuccess(result.message);
//           setError('');
//         } else {
//           setError(result.message);
//           setSuccess('');
//         }
//       }
//     } catch (err) {
//       setError('There was an error logging in. Please try again.');
//     }
//   };

//   return (
//     <div className="container d-flex justify-content-center align-items-center min-vh-100">
//       <div className="form-box text-center p-4 rounded shadow-sm" style={{ maxWidth: '400px', width: '100%', backgroundColor: '#dbc4a9' }}>
//         <img src={A1} alt="item" style={{ width: "60%" }} />
//         <h1 className="text-primary mt-3 mb-4">LOGIN</h1>
//         <form onSubmit={handleSubmit}>
//           <div className="mb-3 position-relative">
//             <input type="email" className="form-control" placeholder="Email" value={email_id} onChange={(e) => setEmailId(e.target.value)} required />
//           </div>
//           <div className="mb-3 position-relative">
//             <input type="password" className="form-control" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
//           </div>

//           {error && <div className="text-danger mb-3">{error}</div>}

//           <div className="forgot-link mb-3">
//             <Link to="/register" style={{ color: 'black' }}>Register</Link>
//           </div>

//           <button type="submit" className="btn btn-primary w-100 py-2 mb-3">Login</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import A1 from '../Images/logo-w.png';

// const Login = () => {
//   const [email_id, setEmailId] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const loginData = { email_id, password };
//     if (email_id === 'admin.erp@gmail.com' && password === 'admin') {
//       const userData = { email: email_id, name: 'Admin', role: 'admin' };
//       const token = 'mock-token-for-admin';
//       sessionStorage.setItem('user', JSON.stringify(userData));
//       sessionStorage.setItem('authToken', token);

//       setSuccess('Login successful!');
//       setError('');
//       navigate('/admindashboard-admindashboard');
//       return;
//     }

//     try {
//       const response = await fetch('https://erpapi.emedha.in/auth/api/login', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(loginData),
//       });

//       const result = await response.json();

//       if (response.ok) {
//         const userData = result.user;
//         const token = result.token;
//         sessionStorage.setItem('user', JSON.stringify(userData));
//         sessionStorage.setItem('authToken', token);
//         setSuccess(result.message);
//         setError('');
//         if (userData.role === 'admin') {
//           navigate('/admindashboard-admindashboard');
//         } else {
//           navigate('/dashboard');
//         }
//       } else {
//         setError(result.message);
//         setSuccess('');
//       }
//     } catch (err) {
//       setError('There was an error logging in. Please try again.');
//       setSuccess('');
//     }
//   };

//   return (
//     <div className="container d-flex justify-content-center align-items-center min-vh-100">
//       <div className="form-box text-center p-4 rounded shadow-sm" style={{ maxWidth: '400px', width: '100%', backgroundColor: '#dbc4a9' }}>
//         <img src={A1} alt="item" style={{ width: "60%" }} />
//         <h1 className="text-primary mt-3 mb-4">LOGIN</h1>
//         <form onSubmit={handleSubmit}>
//           <div className="mb-3 position-relative">
//             <input
//               type="email"
//               className="form-control"
//               placeholder="Email"
//               value={email_id}
//               onChange={(e) => setEmailId(e.target.value)}
//               required
//             />
//           </div>
//           <div className="mb-3 position-relative">
//             <input
//               type="password"
//               className="form-control"
//               placeholder="Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//           </div>

//           {error && <div className="text-danger mb-3">{error}</div>}

          // <div className="forgot-link mb-3">
          //   <Link to="/register" style={{ color: 'black' }}>Register</Link>
          // </div>

//           <button type="submit" className="btn btn-primary w-100 py-2 mb-3">Login</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { FaUser, FaLock } from "react-icons/fa";
import A1 from "../Images/logo-w.png";
import Select from "react-select";
import axios from "axios";
import { FaUser, FaLock, FaIdBadge, FaEnvelope } from "react-icons/fa";
import { FiLogIn } from "react-icons/fi";

const Login = () => {
  const [email_id, setEmailId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedEmpId, setSelectedEmpId] = useState(null);
  const [selectedEmpName, setSelectedEmpName] = useState("");
  const [selectedEmail, setSelectedEmail] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch("https://erpapi.emedha.in/pages/api/user");
        const result = await response.json();
        if (response.ok) {
          setUsers(result.users);
        } else {
          setError("Error fetching users");
        }
      } catch (err) {
        setError("There was an error fetching the users");
      }
    };
    fetchUsers();
  }, []);

  const handleEmpIdChange = (selectedOption) => {
    const empId = selectedOption ? selectedOption.value : "";
    setSelectedEmpId(empId);
    const selectedUser = users.find((user) => user.Emp_id === parseInt(empId));
    if (selectedUser) {
      setSelectedEmpName(selectedUser.Emp_Name);
      setSelectedEmail(selectedUser.email_id);
      setEmailId(selectedUser.email_id);
    } else {
      setSelectedEmpName("");
      setSelectedEmail("");
      setEmailId("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const loginData = { email_id, password };

    if (email_id === "admin.erp@gmail.com" && password === "admin") {
      const userData = { email: email_id, name: "Admin", role: "admin" };
      const token = "mock-token-for-admin";
      sessionStorage.setItem("user", JSON.stringify(userData));
      sessionStorage.setItem("authToken", token);
      setSuccess("Login successful!");
      setError("");
      navigate("/admindashboard-admindashboard");
      return;
    }

    try {
      const response = await fetch("https://erpapi.emedha.in/auth/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginData),
      });

      const result = await response.json();

      if (response.ok) {
        const userData = result.user;
        const token = result.token;
        sessionStorage.setItem("user", JSON.stringify(userData));
        sessionStorage.setItem("authToken", token);
        setSuccess(result.message);
        setError("");
        if (userData.role === "admin") {
          navigate("/admindashboard-admindashboard");
        } else {
          navigate("/dashboard");
        }
      } else {
        setError(result.message);
        setSuccess("");
      }
    } catch (err) {
      setError("There was an error logging in. Please try again.");
      setSuccess("");
    }
  };

  const userOptions = users.map((user) => ({
    value: user.Emp_id,
    label: `${user.Emp_id} -${user.Emp_Name}`,
  }));

  ///
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [step, setStep] = useState(1); // 1: Enter Number, 2: Enter OTP
  const [message, setMessage] = useState("");

  const sendOtp = async () => {
    if (whatsappNumber.length !== 10) {
      setMessage("Please enter a valid 10-digit WhatsApp number.");
      return;
    }

    try {
      const response = await axios.post(
        "https://erpapi.emedha.in/pages/api/api/send-otp",
        {
          whatsappNumber,
        }
      );

      if (response.data.success) {
        setMessage("OTP sent successfully.");
        setOtpCode(response.data.otpCode);
        setStep(2);
      }
    } catch (error) {
      setMessage(error.response?.data?.error || "Error sending OTP.");
    }
  };

  const verifyOtp = async () => {
    if (!otpCode) {
      console.log(otpCode);
      setMessage("Please enter the OTP.");
      return;
    }
  
    try {
      const response = await axios.post(
        "https://erpapi.emedha.in/pages/api/api/verify-otp",
        {
          whatsappNumber,
          otpCode,
        }
      );

      if (response.data.success) {
        setMessage("OTP verified successfully!");
      } else {
        setMessage("Invalid OTP. Try again.");
      }
    } catch (error) {
      setMessage(error.response?.data?.error || "Error verifying OTP.");
    }
  };

  return (
    // <div className="container d-flex justify-content-center align-items-center min-vh-100">
    //   <div
    //     className="form-box text-center p-4 rounded shadow-sm"
    //     style={{ maxWidth: "400px", width: "100%", backgroundColor: "#ffffff",borderRadius:'3px',borderColor:'black' }}
    //   >
    //     <img src={A1} alt="Logo" style={{ width: "60%" }} />
     
    //     {/* <div className="container">
    //   <h2>OTP Verification</h2>

    //   {step === 1 ? (
    //     <>
    //       <input
    //         type="text"
    //         placeholder="Enter WhatsApp Number"
    //         value={whatsappNumber}
    //         onChange={(e) => setWhatsappNumber(e.target.value)}
    //       />
    //       <button onClick={sendOtp}>Send OTP</button>
    //     </>
    //   ) : (
    //     <>
    //       <input
    //         type="text"
    //         placeholder="Enter OTP"
    //         value={otp}
    //         onChange={(e) => setOtp(e.target.value)}
    //       />
    //       <button onClick={verifyOtp}>Verify OTP</button>
    //     </>
    //   )}

    //   {message && <p>{message}</p>}
    // </div> */}

    //     <h1 className="text-primary mt-3 mb-4">Welcome Back!</h1>
    //     <p className="text-muted mb-4">
    //       Please log in to continue to your dashboard.
    //     </p>

    //     <form onSubmit={handleSubmit}>
    //       <div className="row mb-3">
    //         <div className="col-12 col-md-6">
    //           <label className="form-label">
    //             <strong>Select Employee:</strong>
    //           </label>
    //         </div>
    //         <div className="col-12 col-md-6">
    //           <Select
    //             className="form-control"
    //             value={
    //               selectedEmpId
    //                 ? { value: selectedEmpId, label: selectedEmpId }
    //                 : null
    //             }
    //             onChange={handleEmpIdChange}
    //             options={userOptions}
    //             styles={{
    //               container: (provided) => ({
    //                 ...provided,
    //                 width: "100%",
    //               }),
    //               menuPortal: (provided) => ({
    //                 ...provided,
    //                 zIndex: 9999,
    //               }),
    //               menu: (provided) => ({
    //                 ...provided,
    //                 width: "100%",
                   
    //                 overflowY: "auto",
    //               }),
    //               control: (provided) => ({
    //                 ...provided,
    //                 backgroundColor: "transparent",
    //                 height: "35px",
    //                 padding: "4px",
    //                 borderRadius: "5px",
    //                 border: "1px solid #ccc",
    //               }),
    //               singleValue: (provided) => ({
    //                 ...provided,
    //                 color: "black",
    //               }),
    //             }}
    //           />
    //         </div>
    //       </div>

    //       <div className="mb-3 position-relative">
    //         <input
    //           type="text"
    //           className="form-control"
    //           placeholder="Employee Name"
    //           value={selectedEmpName}
    //           readOnly
    //         />
    //       </div>

    //       <div className="mb-3 position-relative">
    //         <div className="input-group">
    //           <span className="input-group-text">
    //             <FaUser />
    //           </span>
    //           <input
    //             type="email"
    //             className="form-control"
    //             placeholder="Email"
    //             value={email_id}
    //             onChange={(e) => setEmailId(e.target.value)}
    //             required
    //             disabled
    //           />
    //         </div>
    //       </div>

    //       <div className="mb-3 position-relative">
    //         <div className="input-group">
    //           <span className="input-group-text">
    //             <FaLock />
    //           </span>
    //           <input
    //             type="password"
    //             className="form-control"
    //             placeholder="Password"
    //             value={password}
    //             onChange={(e) => setPassword(e.target.value)}
    //             required
    //           />
    //         </div>
    //       </div>

    //       {error && <div className="text-danger mb-3">{error}</div>}
    //       {success && <div className="text-success mb-3">{success}</div>}

    //       <button type="submit" className="btn btn-primary w-100 py-2 mb-3">
    //         Login
    //       </button>
    //       <div className="forgot-link mb-3">
    //         <Link to="/whatsapplogin" style={{ color: 'black' }}>
    //         <img
    //                         src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" // Use your WhatsApp icon here
    //                         alt="WhatsApp Icon"
    //                         width="25"
    //                         height="30"
    //                     />
    //                     Login </Link>
    //       </div>
    //     </form>
    //   </div>
    // </div>


//     <div
//   className="container d-flex justify-content-center align-items-center min-vh-100"
//   style={{ backgroundColor: "#f5f7fb" }}
// >
//   <div
//     className="form-box text-center p-5 shadow"
//     style={{
//       maxWidth: "420px",
//       width: "100%",
//       backgroundColor: "#ffffff",
//       borderRadius: "16px",
//     }}
//   >
//     <img src={A1} alt="Logo" style={{ width: "180px"}} />

//     {/* <h4 style={{ fontWeight: "600", letterSpacing: "1px" }}>
//       DYNATECH
//     </h4>
//     <p style={{ fontSize: "14px", color: "#6c757d" }}>
//       Internal Portal
//     </p> */}

//     <hr />

//     <h5 className="mt-4 mb-2" style={{ fontWeight: "600" }}>
//       Sign In
//     </h5>
//     <p className="text-muted mb-4" style={{ fontSize: "14px" }}>
//       Select your ID to auto-fill credentials.
//     </p>

//     <form onSubmit={handleSubmit}>
//       <div className="mb-3 text-start">
//         <label className="form-label text-muted" style={{ fontSize: "12px" }}>
//           EMPLOYEE ID
//         </label>

//         <Select
//           className="form-control"
//           value={
//             selectedEmpId
//               ? { value: selectedEmpId, label: selectedEmpId }
//               : null
//           }
//           onChange={handleEmpIdChange}
//           options={userOptions}
//           styles={{
//             control: (provided) => ({
//               ...provided,
//               borderRadius: "10px",
//               border: "1px solid #ffffff",
//               padding: "2px",
//               height: "45px",
//               boxShadow: "none",
//             }),
//           }}
//         />
//       </div>

//       <div className="mb-3">
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Employee Name"
//           value={selectedEmpName}
//           readOnly
//           style={{
//             borderRadius: "10px",
//             height: "45px",
//             backgroundColor: "#f1f3f5",
//             border: "none",
//           }}
//         />
//       </div>

//       <div className="mb-3">
//         <input
//           type="email"
//           className="form-control"
//           placeholder="Email"
//           value={email_id}
//           onChange={(e) => setEmailId(e.target.value)}
//           required
//           disabled
//           style={{
//             borderRadius: "10px",
//             height: "45px",
//             backgroundColor: "#f1f3f5",
//             border: "none",
//           }}
//         />
//       </div>

//       <div className="mb-4">
//         <input
//           type="password"
//           className="form-control"
//           placeholder="Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//           style={{
//             borderRadius: "10px",
//             height: "45px",
//             border: "1px solid #e0e0e0",
//           }}
//         />
//       </div>

//       {error && <div className="text-danger mb-3">{error}</div>}
//       {success && <div className="text-success mb-3">{success}</div>}

//       <button
//         type="submit"
//         className="w-100"
//         style={{
//           backgroundColor: "#9e9e9e",
//           color: "#fff",
//           border: "none",
//           borderRadius: "12px",
//           padding: "12px",
//           fontWeight: "500",
//           fontSize: "15px",
//         }}
//       >
//         Authorize & Enter →
//       </button>

//       <div className="mt-4">
//         <Link to="/whatsapplogin" style={{ color: "#000" }}>
//           <img
//             src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
//             alt="WhatsApp Icon"
//             width="22"
//             height="22"
//             style={{ marginRight: "8px" }}
//           />
//           Login
//         </Link>
//       </div>
//     </form>

//     <p className="mt-4 text-muted" style={{ fontSize: "12px" }}>
//       SECURE ACCESS SYSTEM
//     </p>
//   </div>
// </div>



<div
  className="container d-flex justify-content-center align-items-center min-vh-100"
  style={{ backgroundColor: "#ffffff" }}
>
  <div
    className="form-box text-center p-5 shadow"
    style={{
      maxWidth: "420px",
      width: "100%",
      backgroundColor: "#ffffff",
      borderRadius: "16px",
    }}
  >
    <img src={A1} alt="Logo" style={{ width: "250px", marginBottom: "10px" }} />
{/* 
    <h4 style={{ fontWeight: "600", letterSpacing: "1px" 789eea }}>
      DYNATECH
    </h4>
    <p style={{ fontSize: "14px", color: "#6c757d" }}>
      Internal Portal
    </p> */}

    <hr />

    <h5 className="mt-4 mb-2" style={{ fontWeight: "600" }}>
      Sign In
    </h5>
    <p className="text-muted mb-4" style={{ fontSize: "14px" }}>
      Select your ID to auto-fill credentials.
    </p>

    <form onSubmit={handleSubmit}>
      
      {/* Employee ID */}
      <div className="mb-3 text-start">
        <label className="form-label text-muted" style={{ fontSize: "12px" }}>
          EMPLOYEE ID
        </label>

        <div className="input-group">
          <span className="input-group-text bg-white border-end-0">
            <FaIdBadge />
          </span>

          <Select
            className="form-control border-start-0"
            value={
              selectedEmpId
                ? { value: selectedEmpId, label: selectedEmpId }
                : null
            }
            onChange={handleEmpIdChange}
            options={userOptions}
            styles={{
              control: (provided) => ({
                ...provided,
                border: "1px solid #e0e0e0",
                borderRadius: "0 10px 10px 0",
                height: "45px",
                boxShadow: "none",
              }),
            }}
          />
        </div>
      </div>

      {/* Employee Name */}
      <div className="mb-3">
        <div className="input-group">
          <span className="input-group-text bg-light border-0">
            <FaUser />
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Employee Name"
            value={selectedEmpName}
            readOnly
            style={{
              borderRadius: "0 10px 10px 0",
              height: "45px",
              backgroundColor: "#f1f3f5",
              border: "none",
            }}
          />
        </div>
      </div>

      {/* Email */}
      <div className="mb-3">
        <div className="input-group">
          <span className="input-group-text bg-light border-0">
            <FaEnvelope />
          </span>
          <input
            type="email"
            className="form-control"
            placeholder="Email"
            value={email_id}
            onChange={(e) => setEmailId(e.target.value)}
            required
            disabled
            style={{
              borderRadius: "0 10px 10px 0",
              height: "45px",
              backgroundColor: "#f1f3f5",
              border: "none",
            }}
          />
        </div>
      </div>

      {/* Password */}
      <div className="mb-4">
        <div className="input-group">
          <span className="input-group-text bg-white border-end-0">
            <FaLock />
          </span>
          <input
            type="password"
            className="form-control border-start-0"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              borderRadius: "0 10px 10px 0",
              height: "45px",
              border: "1px solid #e0e0e0",
            }}
          />
        </div>
      </div>

      {error && <div className="text-danger mb-3">{error}</div>}
      {success && <div className="text-success mb-3">{success}</div>}

      {/* Button */}
      <button
        type="submit"
        className="w-100 d-flex align-items-center justify-content-center gap-2"
        style={{
          backgroundColor: "#9e9e9e",
          color: "#fff",
          border: "none",
          borderRadius: "12px",
          padding: "12px",
          fontWeight: "500",
          fontSize: "15px",
        }}
      >
        Authorize & Enter <FiLogIn />
      </button>

      {/* WhatsApp login */}
      <div className="mt-4">
        <Link to="/whatsapplogin" style={{ color: "#000" }}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp Icon"
            width="22"
            height="22"
            style={{ marginRight: "8px" }}
          />
          Login
        </Link>
      </div>
    </form>

    {/* <p className="mt-4 text-muted" style={{ fontSize: "12px" }}>
      SECURE ACCESS SYSTEM
    </p> */}
  </div>
</div>
  );
};

export default Login;
